export type SessionOutcome = 'start-over' | 'exhausted' | 'none';

const SESSION_EXPIRED = 401;
const OUT_OF_ORDER_OR_IDENTITY_MISMATCH = 409;
const ATTEMPT_CEILING_REACHED = 429;

export const classifySessionOutcome = (code: number | undefined): SessionOutcome => {
  if (code === SESSION_EXPIRED || code === OUT_OF_ORDER_OR_IDENTITY_MISMATCH) return 'start-over';
  if (code === ATTEMPT_CEILING_REACHED) return 'exhausted';
  return 'none';
};
